var _style, _g, _g2, _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnphase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1035.2 188.8",
    style: {
      enableBackground: "new 0 0 1035.2 188.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#mask-2_00000091708756479146184210000015456450926712024463_);fill:#F37320;}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter_00000069360382204470039880000004792568688369365652_);}\n\t.st4{mask:url(#mask-4_00000088124668240060637380000011868295993787625362_);fill:#F37320;}\n\t.st5{fill:#5F5E5E;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_00802_x5F_Enphase_x5F_logo",
    transform: "translate(0.000000, -1.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped",
    transform: "translate(0.000000, 19.429376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1_00000160901962000155383930000012007288836473079475_"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 5.9,
    y: 99.8,
    width: 167.7,
    height: 68.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 5.9,
    y: 99.8,
    width: 167.7,
    height: 68.1,
    id: "mask-2_00000091708756479146184210000015456450926712024463_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_00000148628928206091114940000014719914142452346000_",
    className: "st1",
    points: "5.9,99.8 173.7,99.8  173.7,167.9 5.9,167.9  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st2",
    d: "M89.8,167.9c-35.3,0-67.5-20.2-82.7-52.1c-2.6-5.5-0.3-12.2,5.3-14.8s12.2-0.3,14.9,5.3 c11.9,25.1,37.6,40.5,65.5,39.4c25.8-1.1,48.7-16.2,59.8-39.4c2.6-5.5,9.3-7.9,14.8-5.3c5.6,2.6,8,9.2,5.3,14.8 c-14.6,30.8-44.9,50.7-79,52.2C92.3,167.8,91,167.9,89.8,167.9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-4-Clipped",
    transform: "translate(0.000000, 0.684457)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "path-3_00000024720846456761890320000015450144803848671678_"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000112590708980693385050000016090901350072008585_",
    filterUnits: "userSpaceOnUse",
    x: -0.3,
    y: 2.6,
    width: 180.2,
    height: 102.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.3,
    y: 2.6,
    width: 180.2,
    height: 102.1,
    id: "mask-4_00000088124668240060637380000011868295993787625362_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000112590708980693385050000016090901350072008585_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_00000058564729463466980910000014283938332719866779_",
    className: "st1",
    points: "-0.3,2.6 179.8,2.6  179.8,104.7 -0.3,104.7  "
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st4",
    d: "M168.7,104.7H10.8c-6.2,0-11.2-5-11.2-11.1c0-6.1,5-11.1,11.2-11.1h145.8 c-5.4-32.7-34-57.7-68.3-57.7c-25.8,0-49.4,14.2-61.4,37c-2.8,5.4-9.6,7.5-15.1,4.7c-5.5-2.8-7.6-9.6-4.7-15 C23,21.3,54.1,2.6,88.3,2.6c50.4,0,91.5,40.8,91.6,91c0,2.9-1.2,5.8-3.3,7.9C174.5,103.5,171.6,104.7,168.7,104.7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st5",
    d: "M314.4,136.5h-58.5v-32.2h41.5c5.6,0,10.1-4.5,10.1-10.1c0-5.5-4.5-10-10.1-10h-41.5V56.3h54.3 c5.6,0,10.1-4.5,10.1-10.1c0-5.5-4.5-10-10.1-10h-64.4c-5.6,0-10.1,4.5-10.1,10v100.3c0,5.6,4.5,10.1,10.1,10.1h68.6 c5.6,0,10.1-4.5,10.1-10.1C324.5,141,320,136.5,314.4,136.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st5",
    d: "M1025.2,136.5h-58.5v-32.2h41.5c5.6,0,10.1-4.5,10.1-10.1c0-5.5-4.5-10-10.1-10h-41.5V56.3h54.3 c5.6,0,10.1-4.5,10.1-10.1c0-5.5-4.5-10-10.1-10h-64.4c-5.6,0-10.1,4.5-10.1,10v100.3c0,5.6,4.5,10.1,10.1,10.1h68.6 c5.6,0,10.1-4.5,10.1-10.1C1035.2,141,1030.7,136.5,1025.2,136.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st5",
    d: "M816.1,142.6l-11.7-27.5c0,0,0-0.1,0-0.1l-30.8-72.6c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.2-0.1-0.3-0.2 c0,0,0,0-0.1,0c-0.2-0.1-0.4-0.1-0.5-0.2c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.3-0.1-0.5-0.1c-0.7-0.2-1.4-0.3-2.1-0.3 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.8,0-1.5,0.1-2.3,0.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.2 c-0.2,0.1-0.3,0.1-0.5,0.2c0,0,0,0-0.1,0c-0.1,0.1-0.2,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2,0.1-0.3,0.2-0.4,0.3 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.5c0,0.1-0.1,0.2-0.1,0.3L724.2,115c0,0,0,0.1,0,0.1l-11.7,27.5 c-2.2,5.1,0.2,11,5.4,13.2c1.3,0.5,2.6,0.8,3.9,0.8c3.9,0,7.7-2.3,9.3-6.1l9.1-21.5h48.2l9.1,21.5c1.6,3.8,5.4,6.1,9.3,6.1 c1.3,0,2.6-0.3,3.9-0.8C815.9,153.6,818.3,147.8,816.1,142.6L816.1,142.6z M748.7,108.9l15.6-36.8l15.6,36.8H748.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st5",
    d: "M438.9,156.6h-2.6c-3.1,0-6.1-1.4-8-3.9l-62.7-80v73.8c0,5.5-4.5,10-10.1,10 c-5.6,0-10.1-4.5-10.1-10V46.2c0-5.5,4.5-10,10.1-10h2.1c3.1,0,6.1,1.4,8,3.9l63.2,80.6V46.2c0-5.5,4.5-10,10.1-10 c5.6,0,10.1,4.5,10.1,10v100.3C449,152.1,444.5,156.6,438.9,156.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st5",
    d: "M680.7,36.2c-5.6,0-10.1,4.5-10.1,10v37.9h-57.6V46.2c0-5.5-4.5-10-10.1-10s-10.1,4.5-10.1,10 v48v0v0v52.3c0,5.6,4.5,10,10.1,10s10.1-4.5,10.1-10v-42.3h57.6v42.3c0,5.6,4.5,10,10.1,10s10.1-4.5,10.1-10V46.2 C690.8,40.7,686.3,36.2,680.7,36.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st5",
    d: "M876.6,158.8c-15.2,0-30.8-6-41.6-16.7c-3.9-3.9-4-10.3,0-14.2c3.9-3.9,10.3-3.9,14.3,0 c10.7,10.7,27,12.7,37.6,9.3c4.6-1.5,10.3-4.7,11.3-11.4c0.9-5.7-2.2-11-20.1-18.6c-1.7-0.7-3.1-1.3-4.3-1.9 c-0.8-0.4-2.5-1.1-4.2-1.8c-11.3-4.5-34.8-13.9-34.4-35.6c0.3-13.3,8.3-24.3,21.5-29.7c18.5-7.4,41.8-2.3,56.7,12.5 c4,3.9,4,10.3,0,14.2c-3.9,3.9-10.3,3.9-14.3,0c-10.4-10.3-25.4-11.9-34.9-8.1c-5.8,2.3-8.8,6.2-8.9,11.4 c-0.2,7.8,14.1,13.5,21.7,16.5c2.2,0.9,4.1,1.7,5.7,2.5c0.7,0.3,1.9,0.9,3.3,1.4c10.7,4.6,35.8,15.3,32.1,40.1 c-2,12.9-11.1,22.9-25,27.5C887.8,158,882.2,158.8,876.6,158.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st5",
    d: "M490.8,156.6c-5.6,0-10.1-4.5-10.1-10V46.2c0-5.5,4.5-10.1,10.1-10.1h41.4 c22.6,0,39.1,15.8,39.1,37.6s-16.4,37.6-39.1,37.6h-31.4v35.2C500.9,152.1,496.4,156.6,490.8,156.6L490.8,156.6z M500.9,91.2h31.4 c11.5,0,18.9-6.9,18.9-17.5c0-10.6-7.4-17.5-18.9-17.5h-31.4V91.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnphase);
export default __webpack_public_path__ + "static/media/enphase.4ff08e2ddbd5a210c8b050bd7ae23f3b.svg";
export { ForwardRef as ReactComponent };